export const BRAND_REQUEST_TYPES = [
  {
    id: 11,
    name: "Add Location",
  },
  {
    id: 9,
    name: "Brand Meeting Notes/ Event Reports",
  },
  {
    id: 2,
    name: "Budget Approval / Confirmation / Request",
  },
  {
    id: 1,
    name: "Creative Request",
  },
  {
    id: 6,
    name: "General Request",
  },
  {
    id: 5,
    name: "New Campaign",
  },
  {
    id: 4,
    name: "New Store Opening",
  },
  {
    id: 3,
    name: "Pause Request / Closed Location",
  },
  {
    id: 7,
    name: "Report Request",
  },
  {
    id: 8,
    name: "Targeting Changes",
  },
];

// File type constants
export const AD_COPY_FILE_TYPES = [".csv", ".xlsx", ".zip", ".pdf", ".rar"];
export const CREATIVE_FILE_TYPES = [
  ".jpg",
  ".jpeg",
  ".png",
  ".pdf",
  ".gif",
  ".psd",
  ".mp4",
  ".ai",
  ".rar",
  ".zip",
];
export const ATTACHMENTS_FILE_TYPES = [
  ".csv",
  ".xlsx",
  ".zip",
  ".jpeg",
  ".png",
  ".pdf",
  ".doc",
  ".gif",
  ".psd",
  ".rar",
];
export const LOCATION_DETAIL_FILE_TYPES = [".xlsx", ".csv"];
export const BUDGET_FILE_TYPES = [".xlsx", ".csv", ".rar", ".zip"];
export const AUDIENCE_FILE_TYPES = [".xlsx", ".csv", ".zip", ".rar"];
export const NOTES_FILE_TYPES = [
  ".pdf",
  ".doc",
  ".xlsx",
  ".csv",
  ".rar",
  ".zip",
];
export const LARGE_FILE_SIZE = 5 * 1024 * 1024 * 1024; // 5GB
